/* UTF-8 admin tab: schedule */
import React from 'react'

export function renderSchedule(ctx) {
  const {
    activeTab,
    adminTimeOffRequests,
    handleTimeOffAction,
    setTrackingFilter,
    t,
    timeOffActionMsg,
    trackingFilter,
  } = ctx
  return (
    <>
          {activeTab === 'schedule' && (
            <div className="dash-section">
              <div className="dash-section-header">
                <h2>📅 {t.schedule}</h2>
                <p>Review and approve worker time off and vacation requests.</p>
                {timeOffActionMsg && <span style={{ background: '#d1fae5', color: '#065f46', padding: '4px 12px', borderRadius: 8, fontSize: '0.85rem' }}>{timeOffActionMsg}</span>}
              </div>
              <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
                {['all', 'pending', 'approved', 'denied'].map(s => (
                  <button
                    key={s}
                    className={`dash-btn${trackingFilter === s || (s === 'all' && !trackingFilter) ? ' primary' : ' secondary'} small`}
                    onClick={() => setTrackingFilter(s === 'all' ? '' : s)}
                  >
                    {s === 'all' ? `All (${adminTimeOffRequests.length})` :
                     s === 'pending' ? `⏳ Pending (${adminTimeOffRequests.filter(r=>r.status==='pending').length})` :
                     s === 'approved' ? `✅ Approved (${adminTimeOffRequests.filter(r=>r.status==='approved').length})` :
                     `❌ Denied (${adminTimeOffRequests.filter(r=>r.status==='denied').length})`}
                  </button>
                ))}
              </div>
              {adminTimeOffRequests
                .filter(r => !trackingFilter || r.status === trackingFilter)
                .length === 0 ? (
                  <div className="dash-empty-state"><span>📅</span><p>No time off requests yet.</p></div>
                ) : (
                  <div className="dash-timeoff-admin-list">
                    {adminTimeOffRequests
                      .filter(r => !trackingFilter || r.status === trackingFilter)
                      .map(r => {
                        const icons = { vacation:'🏖️', sick:'🏥', personal:'👤', parental:'👶', bereavement:'🕊️' }
                        const days = Math.round((new Date(r.endDate) - new Date(r.startDate)) / 86400000) + 1
                        return (
                          <div key={r.id} className={`dash-timeoff-card status-${r.status}`}>
                            <div className="dash-timeoff-card-left">
                              <span className="dash-timeoff-card-icon">{icons[r.type] || '📅'}</span>
                              <div>
                                <p className="dash-timeoff-card-worker"><strong>{r.workerName}</strong> <span style={{color:'#6b7280',fontWeight:400}}>({r.department})</span></p>
                                <p className="dash-timeoff-card-type">{r.type?.charAt(0).toUpperCase() + r.type?.slice(1)} · {r.startDate} → {r.endDate} ({days} day{days!==1?'s':''})</p>
                                {r.reason && <p className="dash-timeoff-card-reason">"{r.reason}"</p>}
                                <p style={{fontSize:'0.75rem',color:'#9ca3af'}}>Requested: {new Date(r.requestedAt).toLocaleString()}</p>
                              </div>
                            </div>
                            <div className="dash-timeoff-card-actions">
                              <span className={`dash-timeoff-status-badge ${r.status}`}>
                                {r.status === 'pending' ? '⏳ Pending' : r.status === 'approved' ? '✅ Approved' : '❌ Denied'}
                              </span>
                              {r.status === 'pending' && (
                                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                                  <button className="dash-btn primary small" onClick={() => handleTimeOffAction(r.id, 'approved')}>Approve</button>
                                  <button className="dash-btn danger small" onClick={() => handleTimeOffAction(r.id, 'denied')}>Deny</button>
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                )
              }
            </div>
          )}

          {/* ── POLICY ──────────────────────────────────────── */}
    </>
  )
}
